/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Filter_OnlineInputs */



/**
* | output |
* | --- |
* | "Online events" |
*
* @param {Tournaments_Filter_OnlineInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_filter_online = /** @type {((inputs?: Tournaments_Filter_OnlineInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Filter_OnlineInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Événements en ligne")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eventos en línea")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Eventos online")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eventi online")
	return /** @type {LocalizedString} */ ("Online events")
});